var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "multiselect-popup-container" },
    [
      _c(
        "Multiselect",
        _vm._g(
          _vm._b(
            {
              ref: "ms",
              staticClass: "multiselect-popup-container__multiselect",
              attrs: { "open-direction": "bottom", multiple: false },
              on: { select: _vm.optionSelected, close: _vm.closePopup },
            },
            "Multiselect",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("div", { staticClass: "multiselect-popup-container__close-button" }, [
        _c(
          "button",
          {
            staticClass: "icon-close",
            attrs: { type: "button", title: _vm.t("cookbook", "Close") },
            on: { click: _vm.closePopup },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.t("cookbook", "Close")) +
                "\n        "
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }